import { AnyStruct } from "./types";

export function isOptionalStruct(struct: AnyStruct): boolean {
  return (
    [...struct.validator(undefined, { branch: [], path: [] })].length === 0 &&
    [...struct.refiner(undefined, { branch: [], path: [] })].length === 0
  );
}
